import { BRAND_NAME, language } from "@chef/constants";
import { validateNorwegianSSN, validateSwedishSSN } from "@chef/utils/ssn";

export const intl = (
  {
    no: {
      SIGNUP_PROGRESS_TITLE: "Bra jobbet, nesten i mål!",
      SIGNUP_PROGRESS_SUBTITLE: "Nå trenger vi bare å vite litt mer om deg.",
      YOUR_PERSONAL_INFORMATION: "Dine opplysninger",
      YOUR_NAME: "Ditt navn",
      YOUR_ADDRESS: "Din adresse",
      PERSONAL_NUMBER_LABEL: "Personnummer (DDMMÅÅXXXXX)",
      FIRST_NAME_LABEL: "Fornavn",
      LAST_NAME_LABEL: "Etternavn",
      ADDRESS_LABEL: "Adresse",
      POSTAL_CODE_LABEL: "Postnummer",
      CAN_ONLY_CONTAIN_NUMBERS: "Kan bare inneholde tall",
      MUST_BE_EXACTLY_DIGITS: (digit: number) => `Må være ${digit} siffer`,
      MUST_BE_18_YEARS_OR_OLDER: "[PH] Must be 18 years or older",
      MANDATORY_FIELD: "Påkrevd felt",
      LENGTH_OF_PERSONAL_NUMBER: 11,
      LENGTH_OF_POSTALCODE: 4,
      LENGTH_OF_TELEPHONE_NUMBER: 8,
      TELEPHONE_NUMBER_ALREADY_IN_USE: "Nummeret er i bruk!",
      SKIP_SSN_VALIDATION: true,
      MOVE_TO_NEXT_STEP: "Gå videre",
      WE_CANNOT_DELIVER_HERE: "Beklager, vi kan ikke levere til din adresse",
      CHECK_IF_WE_CAN_DELIVER_HERE: "Sjekker om vi kan levere hit...",

      IS_VALID_SSN: (ssn?: string): boolean => {
        if (!ssn) {
          return false;
        }
        return validateNorwegianSSN(ssn);
      },
    },

    se: {
      SIGNUP_PROGRESS_TITLE: "Snyggt jobbat, snart i mål!",
      SIGNUP_PROGRESS_SUBTITLE: "Nu behöver vi bara veta lite mer om dig.",
      YOUR_PERSONAL_INFORMATION: "Dina uppgifter",
      YOUR_NAME: "Ditt namn",
      YOUR_ADDRESS: "Din adress",
      PERSONAL_NUMBER_LABEL: "Personnummer (ÅÅÅÅMMDDXXXX)",
      FIRST_NAME_LABEL: "Förnamn",
      LAST_NAME_LABEL: "Efternamn",
      ADDRESS_LABEL: "Adress",
      POSTAL_CODE_LABEL: "Postnummer",
      CAN_ONLY_CONTAIN_NUMBERS: "Kan bara innehålla siffror",
      MUST_BE_EXACTLY_DIGITS: (digit: number) =>
        `Måste vara exakt ${digit} siffror`,
      MUST_BE_18_YEARS_OR_OLDER: "Du måste vara 18 år eller äldre",
      MANDATORY_FIELD: "Obligatoriskt fält",
      LENGTH_OF_PERSONAL_NUMBER: 12,
      LENGTH_OF_POSTALCODE: 5,
      LENGTH_OF_TELEPHONE_NUMBER: 10,
      PERSONAL_NUMBER_ALREADY_IN_USE:
        "Ett konto finns redan med detta personnumer, pröva logga in med SMS",
      TELEPHONE_NUMBER_ALREADY_IN_USE:
        "Ett konto finns redan med detta telefonnummer, pröva logga in med SMS",
      PERSONAL_NUMBER_NOT_VALID: "Uppge ett giltig personnummer",
      SKIP_SSN_VALIDATION: false,
      MOVE_TO_NEXT_STEP: "Gå vidare",
      WE_CANNOT_DELIVER_HERE: "Tyvärr, vi kan inte leverera här",
      CHECK_IF_WE_CAN_DELIVER_HERE: "Kollar om vi kan leverera här...",

      IS_VALID_SSN: (ssn?: string): boolean => {
        if (!ssn) {
          return false;
        }

        return validateSwedishSSN(ssn);
      },
    },

    dk: {
      SIGNUP_PROGRESS_TITLE: "Sådan, du er der næsten!",
      SIGNUP_PROGRESS_SUBTITLE: "Nu mangler vi bare lidt oplysninger om dig.",
      YOUR_PERSONAL_INFORMATION: "Dine oplysninger",
      YOUR_NAME: "Dit navn",
      YOUR_ADDRESS: "Din adresse",
      FIRST_NAME_LABEL: "Fornavn",
      LAST_NAME_LABEL: "Efternavn",
      ADDRESS_LABEL: "Adresse",
      POSTAL_CODE_LABEL: "Postnummer",
      CAN_ONLY_CONTAIN_NUMBERS: "Kan kun indeholde tal",
      MUST_BE_EXACTLY_DIGITS: (digit: number) =>
        `Skal være nøjagtigt ${digit} cifre`,
      MUST_BE_18_YEARS_OR_OLDER: "[PH] Must be 18 years or older",
      MANDATORY_FIELD: "Obligatorisk felt",
      LENGTH_OF_PERSONAL_NUMBER: 0, // Keeping this in here for typings, it's not going to be used for anything
      LENGTH_OF_POSTALCODE: 4,
      LENGTH_OF_TELEPHONE_NUMBER: 8,
      TELEPHONE_NUMBER_ALREADY_IN_USE: "Mobilnummer allerede i brug",
      SKIP_SSN_VALIDATION: true,
      WE_CANNOT_DELIVER_HERE: "Beklager, vi kan ikke levere her",
      CHECK_IF_WE_CAN_DELIVER_HERE: "Tjek om vi kan levere her...",

      IS_VALID_SSN: () => {
        //[PH]
        // TODO: Add validation for Danish SSN
        return true;
      },
    },
  } as const
)[language];

export const brand = (
  {
    GL: {
      DEFAULT_TIMEBLOCK_ID: 1,
    },
    AMK: {
      DEFAULT_TIMEBLOCK_ID: 1,
    },
    LMK: {
      DEFAULT_TIMEBLOCK_ID: 20,
    },
    RN: {
      DEFAULT_TIMEBLOCK_ID: 58,
    },
  } as const
)[BRAND_NAME];
